import * as actionTypes from './actionTypes'
import * as API from '../api/job'

export const addjobAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.ADD_JOB_REQUEST, payload: data})
        return API.postJobAddApi(data)
            .then(response => {            	
            	dispatch({type: actionTypes.ADD_JOB_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.ADD_JOB_ERROR, payload:error})    
            })
    }
}

export const updateJobAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.UPDATE_JOB_REQUEST, payload: data})
        return API.UpdateJobAddApi(data)
            .then(response => {             
                dispatch({type: actionTypes.UPDATE_JOB_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.UPDATE_JOB_ERROR, payload:error})    
            })
    }
}

export const jobListByComAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.JOBLIST_PROVIDER_REQUEST, payload: data})
        return API.JobListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.JOBLIST_PROVIDER_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.JOBLIST_PROVIDER_ERROR, payload:error})    
            })
    }
}

export const userJobListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.JOB_LIST_USER_REQUEST, payload: data})
        return API.UserJobListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.JOB_LIST_USER_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.JOB_LIST_USER_ERROR, payload:error})    
            })
    }
}

export const jobStatusAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.JOB_STATUS_REQUEST, payload: data})
        return API.JobStatusApi(data)
            .then(response => {             
                dispatch({type: actionTypes.JOB_STATUS_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.JOB_STATUS_ERROR, payload:error})    
            })
    }
}

export const jobViewAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.JOB_VIEW_STATUS_REQUEST, payload: data})
        return API.jobViewApi(data)
            .then(response => {             
                dispatch({type: actionTypes.JOB_VIEW_STATUS_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.JOB_VIEW_STATUS_ERROR, payload:error})    
            })
    }
}

export const jobEditDataAction = (data) => {
    console.log("data",data)
    return dispatch => {
        dispatch({type: actionTypes.JOB_EDIT_DATA_SET_REQUEST, payload: data})
    }
}







// WEBPACK FOOTER //
// ./src/actions/job.js